module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/icon_consultation-53610c15148c0db60040115af8414303.png";